import styled from 'styled-components';

export interface FlexboxProps {
  flexDirection?: string;
  alignItems?: string;
  justifyContent?: string;
  gap?: string | number;
  width?: string | number;
  flexWrap?: string;
  maxHeight?: string | number;
  overflow?: string;
  margin?: string;
}

const Flexbox = styled.div<FlexboxProps>`
  display: flex;
  flex-direction: ${(props) => (props.flexDirection ? `${props.flexDirection}` : `row`)};
  align-items: ${(props) => (props.alignItems ? `${props.alignItems}` : ``)};
  justify-content: ${(props) => (props.justifyContent ? `${props.justifyContent}` : ``)};
  gap: ${(props) => (typeof props.gap === 'string' ? `${props.gap}` : `${props.gap}px`)};
  width: ${(props) => (typeof props.width === 'string' ? `${props.width}` : `${props.width}px`)};
  flex-wrap: ${(props) => (props.flexWrap ? `${props.flexWrap}` : `nowrap`)};
  max-height: ${({ maxHeight }) => (typeof maxHeight === 'string' ? `${maxHeight}` : `${maxHeight}px`)};
  overflow: ${({ overflow }) => (overflow ? `${overflow}` : ``)};
  margin: ${(props) => (props.margin ? `${props.margin}` : ``)};
`;

export default Flexbox;
